export const ROUTES = {
  HOME: "/",
  TEMPLATES: "/templates",
  TEMPLATE_SETTINGS_FORM_WITH_ID: "/template-settings-form/:id", // for router
  TEMPLATE_SETTINGS_FORM: "/template-settings-form", // to navigate
  SETS: "/sets",
  SET_FORM_WITH_ID: "/set-form/:id", // for router
  SET_FORM: "/set-form", // to navigate
  PRINT_LOCATIONS: "/print-locations",
  DESIGN: "/design",
  DESIGN_WITH_ID: "/design/:id",
  PROJECTS: "/projects",
  CATEGORIES: "/categories",
  CATEGORY_FORM_WITH_ID: "/category-form/:id", // for router
  CATEGORY_FORM: "/category-form", // to navigate
  SUBCATEGORIES: "/subcategories",
  SUBCATEGORY_FORM_WITH_ID: "/subcategory-form/:id", // for router
  SUBCATEGORY_FORM: "/subcategory-form", // to navigate
  USERS: "/users",
  USER_DETAILS: "/user-details/:id",
};
